<script lang="ts">
  import type { Api_Image } from '$lib/types/api/graphql';
  import type { ImageSizes } from '$mds/Image/image';
  import type { Rounded } from '$mds/types';
  import Image from '$mds/Image';

  /** @description user: a user-account object */
  export let user: any = null;
  /** @description name: a name to use for the alt tag if no user is provided */
  export let name: string | null = null;
  /** @description size: a tailwindcss class for sizing the image @example 'w-10 h-10' */
  export let size = '';
  /** @description sizes: an object of breakpoints and their widths @default { xs: 40, sm: 80 }  */
  export let sizes: ImageSizes = { xs: 40, sm: 80 };
  /** @description rounded: a tailwindcss class for rounding the image. @default rounded-2xl */
  export let rounded: Rounded | undefined = 'rounded-2xl';
  /** @description circle: shorthand boolean to force a circle */
  export let circle: boolean = false;
  /** @description border: a tailwindcss class for bordering the image */
  export let border = '';
  /** @description align: a tailwindcss class for aligning the image */
  export let align: string | null = null;
  /** @description metafy: whether or not to use one of the metafy system avatar */
  export let metafy = false;
  /** @description preview: a url to use for preview purposes when editing avatars */
  export let preview: string | Api_Image | null = null;
  let className = '';
  export { className as class };

  const s = v => (typeof v === 'string' ? v : null);

  // Prioritize the preview for updated avatars
  let imageSource: string | null = 'https://static.metafy.gg/avatars/1.jpg';
  $: {
    if (user) {
      if (user) {
        imageSource = s(user.avatar?.url) || s(user.avatar?.original?.url) || user.avatar;
      }
    }
    if (preview) {
      imageSource = s(preview) || s(preview?.original?.url);
    }
    if (metafy) {
      imageSource = 'https://static.metafy.gg/avatars/metafy.png';
    }
  }

  $: if (circle) {
    rounded = 'rounded-full';
  }
</script>

<Image
  src={imageSource}
  fallback="https://static.metafy.gg/avatars/1.jpg"
  alt={(name ?? user?.name) ? (name ?? user?.name) + 'ʼs avatar' : 'Avatar representing this user'}
  fit="crop"
  {rounded}
  {border}
  class="{className} {size} {align} shrink-0 object-cover text-transparent"
  {sizes}
  {...$$restProps}
/>
